var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("h2", [_vm._v("Total ∑ affaires " + _vm._s(_vm.year))]),
      _vm._v(" "),
      _c(
        "el-table",
        {
          staticStyle: { width: "100%", "margin-bottom": "15px" },
          attrs: { data: _vm.data, size: "mini" }
        },
        [
          _c("el-table-column", { attrs: { width: "300" } }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { width: "200" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [_vm._v(_vm._s(scope.row.designationDI))]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c(
            "el-table-column",
            { attrs: { label: "Avril " + _vm.year } },
            [
              _c("el-table-column", {
                attrs: {
                  prop: "Colonne1",
                  label: "Cumulé 01 à 04",
                  width: "120",
                  align: "right"
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _vm._v(_vm._s(_vm._f("toCurrency")(scope.row.Colonne1)))
                      ]
                    }
                  }
                ])
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-table-column",
            { attrs: { label: "Août " + _vm.year } },
            [
              _c("el-table-column", {
                attrs: {
                  prop: "Colonne2",
                  label: "Cumulé 05 à 08",
                  width: "120",
                  align: "right"
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _vm._v(_vm._s(_vm._f("toCurrency")(scope.row.Colonne2)))
                      ]
                    }
                  }
                ])
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-table-column",
            { attrs: { label: "Décembre " + _vm.year } },
            [
              _c("el-table-column", {
                attrs: {
                  prop: "Colonne3",
                  label: "Cumulé 09 à 12",
                  width: "120",
                  align: "right"
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _vm._v(_vm._s(_vm._f("toCurrency")(scope.row.Colonne3)))
                      ]
                    }
                  }
                ])
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }